import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { PricingSchemeLinkContainerModel } from '../../../../../../models/aggregates/erp/pricing-scheme/pricing-scheme-link-container.model';
import { ApiVisa } from '../../shared/api-visa.model';
import { ApiResponseModel } from '../../shared';
import { CopyPricingSchemeDto } from '../../../data-transfer-objects';

@Injectable({ providedIn: "root" })
  export class CopyPricingSchemeService extends BaseApiTemplateService<PricingSchemeLinkContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "copy-pricing-scheme/copy";
  
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "copy-pricing-scheme/copy";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "copy-pricing-scheme/copy";
    this.httpClient = http;
  }
  
  submitFormData(formData: CopyPricingSchemeDto, visa: ApiVisa): Observable<ApiResponseModel<PricingSchemeLinkContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path
    }
    return this.httpClient.post<ApiResponseModel<PricingSchemeLinkContainerModel>>(this.apiUrl, formData, this.getHttpHeader(visa));
  }

  copyPricingSchemeWithItemCriteria(formData: CopyPricingSchemeDto, visa: ApiVisa): Observable<ApiResponseModel<PricingSchemeLinkContainerModel>> {
    let url = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "copy-pricing-scheme/copy-with-item-criteria/backoffice-ep"
    return this.httpClient.post<ApiResponseModel<PricingSchemeLinkContainerModel>>(url, formData, this.getHttpHeader(visa));
  }
}